import styled from 'astroturf/react';

const SaveConfirmationModalWrapper = styled('div')`
  [class*='small-container'] {
    left: calc(50% - 250px) !important;
    top: 30%;
    width: 400px;
    padding: 40px;
    
    button {
      font: normal normal 700 13px / 15px var(--ph-font-family-lato-regular);
      font-size: 13px !important;
      line-height: 1 !important;
      &:hover span {
          border-color: #0F1232;
      }
      &[class*='btn--link-border'] span, span {
        border-bottom: 1px solid transparent;
      }
    }

    [class*='modal-title'] {
      text-align: center;
      margin-bottom: 30px;
      font-weight: 700;
    }

    [class*='btn--solid'] {
      background: rgb(15 242 178 / var(--tw-border-opacity)) !important;
    }
    
    [class*='saq-modal-body'] {
      p {
        text-align: center;
        margin-bottom: 5px;
      }
      margin-bottom: 30px;

    }
  }
`;

const SaveModalTitle = styled('span')`
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: var(--ph-heading-three);
`;

const SaveModalButtonsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  gap: 20px;

  [class*='button-wrapper'] {
    margin-left: 0px;
    padding: 0 35px;
  }
`

export default {
  SaveModalButtonsWrapper,
  SaveModalTitle,
  SaveConfirmationModalWrapper
}
